import React from 'react';
import styled from 'styled-components';
import tag from 'clean-tag';
import { themeGet } from 'styled-system';
import { Link as RouterLink } from 'react-router-dom';
import { Box } from '../Layout';

const WrapperLink = styled(RouterLink)`
  display: block;
  transition: all 0.25s linear;
  background: white;
  box-shadow: 0 2px 11px 0 rgba(0, 0, 0, 0.11);
  min-height: 400px;
  width: 30%;
  margin-top: 20px;
  text-decoration: none;
  color: ${themeGet('colors.ui.text')};
  &:hover {
    box-shadow: 0 2px 11px 0 rgba(0, 0, 0, 0.3);
  }

  @media (max-width: ${themeGet('breakpoints.1')}) {
    width: 100%;
  }
`;

const Image = styled(tag.img)`
  width: 100%;
  height: 200px;
  object-fit: cover;
`;

const Text = styled(Box)`
  text-decoration: none;
`;

const Heading = styled(Box)`
  margin-bottom: 10px;
  font-weight: bold;
  color: ${themeGet('colors.brand.primary')};
`;

const PromoBox = ({ img, heading, description, link }) => (
  <WrapperLink to={link}>
    <Image src={img} height="50%" width="100%" />
    <Box p={6}>
      <Heading>{heading}</Heading>
      <Text>{description}</Text>
    </Box>
  </WrapperLink>
);

export default PromoBox;



// WEBPACK FOOTER //
// ./src/PromoBox/PromoBox.js